module.exports = __webpack_public_path__ + "img/avax.a262d362.png";